import React from "react";
import PropTypes from "prop-types";

// Components
import { Row, Col, Form } from "react-bootstrap";

export const SettingItem = ({
  title,
  property,
  value = false,
  handleClick,
  className = "",
  children,
}) => (
  <>
    <Row className={`align-items-center ${className} setting-item-row`}>
      <Col className="setting-item-title">{title}</Col>
      <Col align="right">
        <Form.Check
          type="switch"
          id={`setting-${property}-switch`}
          label=""
          onChange={() => handleClick(property)}
          checked={value}
          data-testid={`setting-${property}-switch`}
        />
      </Col>
    </Row>
    {children}
    <hr />
  </>
);

SettingItem.propTypes = {
  title: PropTypes.string.isRequired,
  property: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.elementType,
  value: PropTypes.bool,
};

export default SettingItem;
